module.exports = __webpack_public_path__ + "img/22.1bcebce5.png";